import {QuestionsAPI} from 'api/questions';
import {TrackingAPI} from 'api/tracking';
import {QuestionList} from 'components/questions/list';
import {useEffect} from 'react';
import {IQPage} from 'types/page';
import {withUser} from 'users';

const QuestionListPage: IQPage<Props> = ({questions, categories}) => {
  useEffect(() => {
    TrackingAPI.questionListViewed();
  }, []);

  return (
    <main>
      <QuestionList categories={categories} questions={questions} />
    </main>
  );
};

QuestionListPage.layoutConfig = {
  useClarity: true,
};

export default QuestionListPage;

type Props = {
  questions: Question[];
  categories: QuestionCategory[];
  user: User;
};

export const getServerSideProps = withUser<Props>({}, async (context, user) => {
  const [questions, categories] = await Promise.all([
    QuestionsAPI.getQuestions(),
    QuestionsAPI.getCategories(),
  ]);
  return {props: {questions, categories, user}};
});
